import * as Sentry from '@sentry/react';
import { isNetworkError } from 'axios-retry';

import { getFeatureFlags, IFeatureFlag } from '../queries/feature_flags/useFeatureFlags';
import authService from '../services/auth';

export const UNREACHABLE_API_REASON = 'AMP could not be reached. Check your VPN connection and try again.';
export const REJECTED_SIGN_IN_REASON =
  'Entra signed you in, but AMP declined the session. Ask an AMP admin to check that your account is active.';

export interface ISignInResult {
  signedIn: boolean;
  reason?: string;
}

const setupFeatureFlags = (featureFlagsData: IFeatureFlag[]) => {
  if (featureFlagsData && Object.keys(window.__amp_feature_flags).length === 0) {
    featureFlagsData.forEach(
      feature_flag => (window.__amp_feature_flags[feature_flag.feature_name] = feature_flag.enabled)
    );
  }
};

const failureReason = (error: unknown) => (isNetworkError(error) ? UNREACHABLE_API_REASON : REJECTED_SIGN_IN_REASON);

export const signInToAmp = async (
  setIsAuthenticatedToBackend: (isAuthenticatedToBackend: boolean) => void
): Promise<ISignInResult> => {
  try {
    const [, featureFlagsData] = await Promise.all([authService.fetchCurrentUser(), getFeatureFlags()]);

    setupFeatureFlags(featureFlagsData.feature_flags);
    setIsAuthenticatedToBackend(true);
    return { signedIn: true };
  } catch (error) {
    Sentry.isInitialized() && Sentry.captureException(error);
    setIsAuthenticatedToBackend(false);
    return { signedIn: false, reason: failureReason(error) };
  }
};
